import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicLink, PrismicRichText } from '@prismicio/react'

const Hero = ({ slice }) => {
  return (
    <section className={`component-${slice.slice_type} bg-white overflow-hidden relative pb-24 sm:pb-30 my-5`}>
      <div className='absolute inset-0'>
        {slice.primary.image.gatsbyImageData && <GatsbyImage image={slice.primary.image.gatsbyImageData} className='w-full h-full object-cover filter grayscale' alt={slice.primary.image.alt || ''} />}
        <div className='absolute inset-0 bg-gradient-to-tr from-fuchsia-800 via-indigo-800 to-teal-600' style={{ mixBlendMode: 'multiply' }} aria-hidden='true' />
      </div>
      <div className='relative mt-24 sm:mt-30 text-center sm:text-left max-w-screen-xl mx-auto px-6 lg:px-8'>
        <div className='mt-10 mx-auto sm:px-6 sm:mt-12 md:mt-16 lg:mt-20 xl:mt-28 text-white space-y-8'>
          <h2 className='text-4xl sm:text-5xl md:text-6xl' itemProp='name'>
            {slice.primary.title.text}
          </h2>
          {slice.primary.text && (
            <div className='prose-invert prose prose-lg lg:prose-xl min-w-full' itemProp='headline'>
              <PrismicRichText field={slice.primary.text.richText} />
            </div>
          )}
          {slice.primary.button_link && slice.primary.button_text && (
            <div className='mx-auto flex justify-center sm:justify-start'>
              <PrismicLink className='flex items-center justify-center button button-lg' field={slice.primary.button_link}>
                {slice.primary.button_text}
              </PrismicLink>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Hero
